module.exports = __webpack_public_path__ + "img/download.e8511d19.svg";